import styled from "@emotion/styled";
import {
  Accordion,
  AccordionSummary,
  Box,
  FormControl,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { shouldForwardProp } from "../../../common/Common.style";
import theme from "../../../theme";

type AccordionProps = {
  expanded: boolean;
};

export const NotificationsAccordionSummary = styled(AccordionSummary)`
  & > :first-of-type {
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;

export const NotificationSettingsItem = styled(Accordion, {
  shouldForwardProp: prop =>
    shouldForwardProp<AccordionProps>(["expanded"], prop),
})<AccordionProps>(({ expanded }) => ({
  minHeight: "56px",
  cursor: "pointer",
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: "4px",
  boxShadow: "none",

  "&:hover": {
    background: !expanded ? `${theme.message?.messageBackground}` : undefined,
  },

  "&:before": {
    display: "none",
  },
}));

export const RadioGroupLabel = styled(Typography)`
  margin-top: 8px;
  font-size: 14px;
  color: ${theme.palette.grey[900]};
`;

export const RadioButtonWrapper = styled(Box)`
  display: flex;
  align-items: center;
  height: 56px;
  border: 1px solid ${theme.palette.grey[200]};
  border-radius: 4px;
  padding: 0 16px;
  margin-top: 10px;
`;

export const RadioGroupContainer = styled(FormControl)`
  width: 100%;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  & > .MuiFormControlLabel-label {
    font-size: 15px !important;
    font-weight: 500 !important;
    color: ${theme.palette.grey[700]} !important;
  }
`;
